
/* Cosmora V4 bundle quantity controls. The selector changes quantity only; pricing/discount rules remain controlled by Shopify. */
document.addEventListener('click',function(e){
  var option=e.target.closest('[data-bundle-qty]'); if(!option)return;
  var bundle=option.closest('[data-cosmora-bundle]'); if(!bundle)return;
  bundle.querySelectorAll('[data-bundle-qty]').forEach(function(b){var active=b===option;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',active?'true':'false');});
  var qty=option.getAttribute('data-bundle-qty');
  var scope=bundle.closest('form') || bundle.closest('pagepilot-product-form-component') || bundle.closest('.product') || document;
  var input=scope.querySelector('input[name="quantity"]');
  if(input){input.value=qty;input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));}
});
document.addEventListener('change',function(e){
  if(!e.target.matches('input[name="quantity"]'))return;
  var scope=e.target.closest('form') || e.target.closest('pagepilot-product-form-component') || e.target.closest('.product'); if(!scope)return;
  var bundle=scope.querySelector('[data-cosmora-bundle]'); if(!bundle)return;
  bundle.querySelectorAll('[data-bundle-qty]').forEach(function(b){var active=b.getAttribute('data-bundle-qty')===String(e.target.value);b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',active?'true':'false');});
});

// Make the initial bundle choice explicit for assistive tech and visual state.
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-cosmora-bundle]').forEach(function(bundle){
    bundle.querySelectorAll('[data-bundle-qty]').forEach(function(b){
      b.setAttribute('aria-pressed',b.classList.contains('is-active')?'true':'false');
    });
  });
});


/* V4.5: keep PagePilot/Dawn bundle selection visually explicit even after dynamic section renders. */
(function(){
  function syncBundle(bundle, qty){
    var value=String(qty || '1');
    bundle.querySelectorAll('[data-bundle-qty]').forEach(function(btn){
      var active=btn.getAttribute('data-bundle-qty')===value;
      btn.classList.toggle('is-active',active);
      btn.setAttribute('aria-pressed',active?'true':'false');
      var badge=btn.querySelector('.cosmora-bundle__selected');
      if(badge) badge.textContent='Selected';
    });
  }
  function initBundle(bundle){
    if(!bundle || bundle.dataset.cosmoraV45Init==='1') return;
    bundle.dataset.cosmoraV45Init='1';
    var active=bundle.querySelector('[data-bundle-qty].is-active,[data-bundle-qty][aria-pressed="true"]');
    syncBundle(bundle,active?active.getAttribute('data-bundle-qty'):'1');
  }
  function scan(){document.querySelectorAll('[data-cosmora-bundle]').forEach(initBundle)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan); else scan();
  new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-bundle-qty]'); if(!btn)return;
    var bundle=btn.closest('[data-cosmora-bundle]'); if(!bundle)return;
    syncBundle(bundle,btn.getAttribute('data-bundle-qty'));
  },true);
})();


/* V8.6: measured, JS-driven promo ticker.
   This intentionally does not depend on CSS @keyframes, so it keeps moving in
   Shopify preview, Chrome/Safari, desktop and mobile. Two identical promo groups
   make the reset invisible. */
(function(){
  function initCosmoraTicker(){
    var ticker=document.querySelector('[data-cosmora-offer-ticker]');
    var viewport=document.querySelector('[data-cosmora-offer-viewport]');
    var track=document.querySelector('[data-cosmora-offer-track]');
    if(!ticker || !viewport || !track || track.dataset.cosmoraTickerReady==='1') return;
    var groups=track.querySelectorAll('.cosmora-offer-ticker__group');
    if(groups.length<2) return;

    track.dataset.cosmoraTickerReady='1';
    track.style.setProperty('animation','none','important');
    track.style.setProperty('transform','translate3d(0,0,0)','important');
    groups.forEach(function(group){group.style.setProperty('display','flex','important');});

    var x=0;
    var loopWidth=0;
    var last=performance.now();
    var raf=0;
    var speed=window.matchMedia('(max-width: 749px)').matches ? 36 : 42; // px/sec

    function measure(){
      // The first duplicated group is exactly one seamless loop.
      loopWidth=groups[0].getBoundingClientRect().width || groups[0].scrollWidth || viewport.clientWidth;
      speed=window.matchMedia('(max-width: 749px)').matches ? 36 : 42;
      if(loopWidth>0){
        while(x<=-loopWidth) x+=loopWidth;
        while(x>0) x-=loopWidth;
      }
    }

    function frame(now){
      var dt=Math.min((now-last)/1000,.08);
      last=now;
      if(loopWidth>0){
        x-=speed*dt;
        if(x<=-loopWidth) x+=loopWidth;
        track.style.setProperty('transform','translate3d('+x.toFixed(2)+'px,0,0)','important');
      }
      raf=requestAnimationFrame(frame);
    }

    measure();
    requestAnimationFrame(function(){measure(); last=performance.now(); raf=requestAnimationFrame(frame);});
    window.addEventListener('resize',measure,{passive:true});
    if('ResizeObserver' in window){
      new ResizeObserver(measure).observe(groups[0]);
    }
    document.addEventListener('visibilitychange',function(){last=performance.now();});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCosmoraTicker); else initCosmoraTicker();
})();

/* V9.2 — keep the proven PagePilot purchase layout intact.
   Only remove the extra hero clutter we already agreed to remove. PagePilot's
   native post-ATC guarantee/returns row stays directly below Add to Cart, and
   the "Less than 1%..." guarantee stays in its native position after the
   accordions on the right. No gallery wrapping or cross-column DOM moves. */
(function(){
  function setupProductFlow(){
    if(!document.body.classList.contains('template-product')) return;
    document.querySelectorAll('.pp-product-information').forEach(function(section){
      var details=section.querySelector('.pp-product-details');
      if(!details) return;
      var stickyWrap=details.firstElementChild;
      var blocksWrap=stickyWrap && stickyWrap.firstElementChild;
      if(!blocksWrap || blocksWrap.children.length < 2) return;

      var children=Array.prototype.slice.call(blocksWrap.children);
      var lowStock=null;
      children.forEach(function(el){
        var txt=(el.textContent||'').replace(/\s+/g,' ').trim();
        if(/Warning:\s*Low Stock Notice/i.test(txt) || /sold out\s+\d+\s+times last year/i.test(txt)) lowStock=el;
      });
      if(lowStock){
        lowStock.dataset.cosmoraLowStockRemoved='true';
        lowStock.style.setProperty('display','none','important');
      }

      /* PagePilot commonly places one promotional testimonial at the end of the
         purchase card in addition to the full reviews section. Remove only that
         duplicate hero testimonial so the first screen stays quiet and personal. */
      var visible=Array.prototype.slice.call(blocksWrap.children).filter(function(el){
        return el!==lowStock && getComputedStyle(el).display!=='none';
      });
      var featuredReview=null;
      for(var i=visible.length-1;i>=0;i--){
        var candidate=visible[i];
        var candidateText=(candidate.textContent||'').replace(/\s+/g,' ');
        var isReviewJump=candidate.matches('.pp-reviews-number,pagepilot-reviews-number') || !!candidate.querySelector('.pp-reviews-number,pagepilot-reviews-number');
        var looksLikeReview=!!candidate.querySelector('.swiper,pagepilot-carousel') || ((/verified purchase|★{3,}/i.test(candidateText)) && candidateText.length>90);
        var looksLikeFullReviews=/what customers|reviews?\s*\(/i.test(candidateText) && candidate.querySelectorAll('article,[class*="review-card"]').length>2;
        if(!isReviewJump && looksLikeReview && !looksLikeFullReviews){ featuredReview=candidate; break; }
      }
      if(featuredReview){
        featuredReview.dataset.cosmoraFeaturedReviewRemoved='true';
        featuredReview.style.setProperty('display','none','important');
      }

      /* Fail-safe for old/custom remnants. These stay out of the compact hero on
         current and future PagePilot product pages. */
      details.querySelectorAll('.cosmora-quality-card,.cosmora-projector-compare,.cosmora-backpulse-compare,.cosmora-inline-review').forEach(function(el){
        el.style.setProperty('display','none','important');
      });

      /* Preserve the requested purchase-card order on current AND newly generated
         PagePilot pages. These are small within-column moves only — no gallery
         wrapping, no redesign, and no cross-column DOM changes. */
      var purchaseChildren=Array.prototype.slice.call(blocksWrap.children);
      var buyBlock=null, trustBlock=null, accordionBlock=null;
      var existingClaimCard=blocksWrap.querySelector(':scope > .cosmora-guarantee-card');
      var claimBlock=existingClaimCard ? existingClaimCard.firstElementChild : null;
      purchaseChildren.forEach(function(el){
        var txt=(el.textContent||'').replace(/\s+/g,' ').trim();
        if(!buyBlock && (el.matches('.buy-buttons-block') || el.querySelector('pagepilot-product-form-component form[data-type="add-to-cart-form"]'))) buyBlock=el;
        if(!trustBlock && /30-Day Money-Back Guarantee/i.test(txt) && /30 Day Returns/i.test(txt) && !/Less than 1%/i.test(txt)) trustBlock=el;
        if(!accordionBlock && (el.matches('pagepilot-accordion,.pp-accordion') || el.querySelector('pagepilot-accordion,.pp-accordion') || (/Description/i.test(txt) && /Shipping\s*&\s*Returns/i.test(txt)))) accordionBlock=el;
        if(!claimBlock && !/30 Day Returns/i.test(txt) && (
          /Less than 1% of customers claim our Money Back Guarantee/i.test(txt) ||
          /Questions\? We[’']re here to help/i.test(txt) ||
          /30-day money-back guarantee\s*[—-]\s*policy details are available below/i.test(txt)
        )) claimBlock=el;
      });

      if(trustBlock){
        trustBlock.style.removeProperty('display');
        if(buyBlock && buyBlock.nextElementSibling!==trustBlock) buyBlock.insertAdjacentElement('afterend',trustBlock);
      }
      if(claimBlock){
        claimBlock.style.removeProperty('display');
        claimBlock.classList.remove('cosmora-gallery-guarantee','cosmora-guarantee-claim');
        claimBlock.classList.add('cosmora-guarantee-claim-content');

        /* Normalize the guarantee wording across older, current and newly
           generated PagePilot products without replacing the icon/group markup. */
        var claimText=Array.prototype.slice.call(claimBlock.querySelectorAll('p')).find(function(el){
          return /money[- ]back guarantee|questions\?|support@cosmora\.us/i.test(el.textContent||'');
        });
        if(claimText && claimText.textContent.trim()!=='Questions? We’re here to help — support@cosmora.us') {
          claimText.textContent='Questions? We’re here to help — support@cosmora.us';
        }

        /* Keep the Customer Support icon identical on every PagePilot product.
           Older products may still carry the original heart icon in their
           template, so normalize the rendered icon globally at runtime. */
        var supportIcon=claimBlock.querySelector('.pp-icon');
        if(supportIcon){
          supportIcon.style.setProperty('--icon-color','#3157e8');
          supportIcon.style.setProperty('--icon-size','20px');
          supportIcon.style.setProperty('--icon-size-mobile','20px');
          supportIcon.style.setProperty('--background-size','20px');
          supportIcon.style.setProperty('--background-size-mobile','20px');

          var currentIcon=supportIcon.querySelector('[data-lucide],svg');
          var currentName=currentIcon && currentIcon.getAttribute ? currentIcon.getAttribute('data-lucide') : '';
          if(currentName!=='info' || !supportIcon.dataset.cosmoraSupportInfoIcon){
            supportIcon.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" data-lucide="info"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>';
            supportIcon.dataset.cosmoraSupportInfoIcon='true';
          }
        }

        /* PagePilot group elements can render their own internal wrapper, so a
           real outer card guarantees the border is visible on every template. */
        var claimCard=claimBlock.parentElement && claimBlock.parentElement.classList.contains('cosmora-guarantee-card')
          ? claimBlock.parentElement
          : existingClaimCard;
        if(!claimCard){
          claimCard=document.createElement('div');
          claimCard.className='cosmora-guarantee-card';
          claimBlock.parentNode.insertBefore(claimCard,claimBlock);
          claimCard.appendChild(claimBlock);
        }
        if(accordionBlock && accordionBlock.nextElementSibling!==claimCard) accordionBlock.insertAdjacentElement('afterend',claimCard);
      }

      section.dataset.cosmoraFlowReady='1';
    });
  }

  function scan(){
    setupProductFlow();
    setTimeout(setupProductFlow,250);
    setTimeout(setupProductFlow,900);
    setTimeout(setupProductFlow,1800);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan); else scan();
  new MutationObserver(function(){setupProductFlow();}).observe(document.documentElement,{childList:true,subtree:true});
})();

/* V8.3: future-proof PagePilot bundle restore without observer feedback loops. */
(function(){
  var copy={
    '1':['Buy 1','Single'],
    '2':['Buy 1, Get 1','2nd 50% off'],
    '3':['Buy 2, Get 1 Free','Best value']
  };
  var bundleHTML=''
    + '<div class="cosmora-bundle" data-cosmora-bundle>'
    +   '<div class="cosmora-bundle__head"><strong>Choose your bundle</strong></div>'
    +   '<div class="cosmora-bundle__options" role="group" aria-label="Choose quantity">'
    +     '<button type="button" class="cosmora-bundle__option is-active" data-bundle-qty="1" aria-pressed="true"><span class="cosmora-bundle__choice">Buy 1</span><small>Single</small><b class="cosmora-bundle__selected" aria-hidden="true">Selected</b></button>'
    +     '<button type="button" class="cosmora-bundle__option" data-bundle-qty="2" aria-pressed="false"><span class="cosmora-bundle__choice">Buy 1, Get 1</span><small>2nd 50% off</small><b class="cosmora-bundle__selected" aria-hidden="true">Selected</b></button>'
    +     '<button type="button" class="cosmora-bundle__option" data-bundle-qty="3" aria-pressed="false"><span class="cosmora-bundle__choice">Buy 2, Get 1 Free</span><small>Best value</small><b class="cosmora-bundle__selected" aria-hidden="true">Selected</b></button>'
    +   '</div>'
    + '</div>';

  function setText(el,value){ if(el && el.textContent!==value) el.textContent=value; }
  function normalizeBundle(bundle){
    if(!bundle) return;
    var head=bundle.querySelector('.cosmora-bundle__head');
    if(head){
      var strong=head.querySelector('strong');
      if(!strong){ strong=document.createElement('strong'); head.prepend(strong); }
      setText(strong,'Choose your bundle');
      Array.prototype.slice.call(head.children).forEach(function(child){ if(child!==strong) child.remove(); });
    }
    bundle.querySelectorAll('[data-bundle-qty]').forEach(function(btn){
      var data=copy[btn.getAttribute('data-bundle-qty')];
      if(!data) return;
      var choice=btn.querySelector('.cosmora-bundle__choice') || btn.querySelector('span');
      var small=btn.querySelector('small');
      var badge=btn.querySelector('.cosmora-bundle__selected');
      setText(choice,data[0]); setText(small,data[1]); setText(badge,'Selected');
    });
  }

  function restorePagePilotBundles(root){
    var scope=(root && root.querySelectorAll)?root:document;
    var forms=[];
    if(scope.matches && scope.matches('.buy-buttons-block pagepilot-product-form-component form[data-type="add-to-cart-form"]')) forms.push(scope);
    scope.querySelectorAll('.buy-buttons-block pagepilot-product-form-component form[data-type="add-to-cart-form"]').forEach(function(f){forms.push(f)});
    forms.forEach(function(form){
      var existing=form.querySelector('[data-cosmora-bundle]');
      if(existing){ normalizeBundle(existing); return; }
      var buttons=form.querySelector('.pp-buy-buttons');
      if(!buttons) return;
      buttons.insertAdjacentHTML('afterbegin',bundleHTML);
      var bundle=buttons.querySelector('[data-cosmora-bundle]');
      normalizeBundle(bundle);
      var qty=form.querySelector('input[name="quantity"]');
      var value=qty && qty.value ? String(qty.value) : '1';
      bundle.querySelectorAll('[data-bundle-qty]').forEach(function(btn){
        var active=btn.getAttribute('data-bundle-qty')===value;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-pressed',active?'true':'false');
      });
    });
  }

  function scan(){ restorePagePilotBundles(document); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan); else scan();
  document.addEventListener('shopify:section:load',function(e){restorePagePilotBundles(e.target||document)});

  var queued=false;
  new MutationObserver(function(mutations){
    var needsScan=false;
    for(var i=0;i<mutations.length && !needsScan;i++){
      for(var j=0;j<mutations[i].addedNodes.length;j++){
        var node=mutations[i].addedNodes[j];
        if(node.nodeType===1 && (node.matches('[data-cosmora-bundle], .buy-buttons-block, pagepilot-product-form-component') || node.querySelector('[data-cosmora-bundle], .buy-buttons-block, pagepilot-product-form-component'))){ needsScan=true; break; }
      }
    }
    if(needsScan && !queued){ queued=true; requestAnimationFrame(function(){queued=false;scan();}); }
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* V5.21: centered smart Cosmora header.
   - Sticky navigation lives globally below the offer ticker.
   - Hides on intentional downward scroll and returns immediately when scrolling up.
   - Mobile menu stays lightweight and accessible.
   - Cart remains Dawn/PagePilot's native drawer; customer account uses Shopify's native account sheet. */
(function(){
  function initCosmoraSmartHeader(){
    var header=document.querySelector('[data-cosmora-smart-header]');
    if(!header || header.dataset.cosmoraHeaderReady==='1') return;
    header.dataset.cosmoraHeaderReady='1';

    var toggle=header.querySelector('[data-cosmora-menu-toggle]');
    var menu=header.querySelector('[data-cosmora-mobile-menu]');
    var account=header.querySelector('shopify-account');
    var accountOpen=false;
    var lastY=Math.max(window.scrollY||0,0);
    var ticking=false;
    var designMode=document.documentElement.classList.contains('shopify-design-mode');

    function setMenu(open){
      if(!toggle || !menu) return;
      toggle.setAttribute('aria-expanded',open?'true':'false');
      menu.hidden=!open;
      header.classList.toggle('menu-open',open);
      if(open) header.classList.remove('is-hidden');
    }
    function closeMenu(){setMenu(false)}

    if(toggle && menu){
      toggle.addEventListener('click',function(){
        setMenu(toggle.getAttribute('aria-expanded')!=='true');
      });
      menu.addEventListener('click',function(e){
        if(e.target.closest('a')) closeMenu();
      });
      document.addEventListener('keydown',function(e){
        if(e.key==='Escape' && toggle.getAttribute('aria-expanded')==='true'){
          closeMenu();
          toggle.focus();
        }
      });
      document.addEventListener('click',function(e){
        if(toggle.getAttribute('aria-expanded')==='true' && !header.contains(e.target)) closeMenu();
      });
    }

    header.addEventListener('focusin',function(){ header.classList.remove('is-hidden'); });

    if(account){
      account.addEventListener('open',function(){
        accountOpen=true;
        header.classList.remove('is-hidden');
        closeMenu();
      });
      account.addEventListener('close',function(){ accountOpen=false; });
    }

    function updateHeader(){
      ticking=false;
      var y=Math.max(window.scrollY||0,0);
      var delta=y-lastY;
      var menuOpen=toggle && toggle.getAttribute('aria-expanded')==='true';
      var overlayOpen=document.body.classList.contains('overflow-hidden') || accountOpen;

      if(designMode || y<90 || menuOpen || overlayOpen){
        header.classList.remove('is-hidden');
      }else if(delta>6){
        header.classList.add('is-hidden');
      }else if(delta<-2){
        header.classList.remove('is-hidden');
      }
      lastY=y;
    }

    window.addEventListener('scroll',function(){
      if(!ticking){
        window.requestAnimationFrame(updateHeader);
        ticking=true;
      }
    },{passive:true});

    window.addEventListener('resize',function(){
      if(window.innerWidth>=750) closeMenu();
      header.classList.remove('is-hidden');
      lastY=Math.max(window.scrollY||0,0);
    },{passive:true});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCosmoraSmartHeader);
  else initCosmoraSmartHeader();
  document.addEventListener('shopify:section:load',initCosmoraSmartHeader);
})();

// Cosmora V7.1: reliable direct path from the purchase area to customer feedback.
(function(){
  function prepareReviewTarget(){
    var target=document.querySelector('#cosmora-customer-reviews') || document.querySelector('.pp-reviews-section') || document.querySelector('.jdgm-rev-widg') || document.querySelector('.jdgm-widget') || document.querySelector('#pp-reviews');
    if(!target) return;
    if(!target.id) target.id='cosmora-customer-reviews';
    target.style.scrollMarginTop='110px';
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',prepareReviewTarget); else prepareReviewTarget();
  document.addEventListener('shopify:section:load',prepareReviewTarget);
  new MutationObserver(prepareReviewTarget).observe(document.documentElement,{childList:true,subtree:true});
})();

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-cosmora-review-jump]');
  if (!trigger) return;
  const target = document.querySelector('#cosmora-customer-reviews') ||
    document.querySelector('.pp-reviews-section') ||
    document.querySelector('.jdgm-rev-widg') ||
    document.querySelector('.jdgm-widget') ||
    document.querySelector('#pp-reviews');
  if (!target) return;
  event.preventDefault();
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
});

/* V6.5: keep PagePilot percentage proof from flashing or settling on an incorrect 0%.
   We never invent a percentage: positive values come only from the block's own
   data-percentage attribute, and a genuinely configured 0% block is hidden. */
(function(){
  function normalizePercentageCircles(root){
    var scope=(root && root.querySelectorAll)?root:document;
    scope.querySelectorAll('pagepilot-percentage-circle[data-percentage]').forEach(function(circle){
      var raw=circle.getAttribute('data-percentage');
      var value=Number(raw);
      if(!Number.isFinite(value)) return;
      if(value<=0){
        circle.style.setProperty('display','none','important');
        circle.setAttribute('aria-hidden','true');
        return;
      }
      var label=circle.querySelector('[ref="value"]');
      var desired=String(Math.round(value))+'%';
      if(label && label.textContent.trim()!==desired) label.textContent=desired;
    });
  }
  function scan(){
    normalizePercentageCircles(document);
    window.setTimeout(function(){normalizePercentageCircles(document)},120);
    window.setTimeout(function(){normalizePercentageCircles(document)},700);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan); else scan();
  document.addEventListener('shopify:section:load',scan);
  new MutationObserver(function(mutations){
    for(var i=0;i<mutations.length;i++){
      if(mutations[i].addedNodes && mutations[i].addedNodes.length){
        normalizePercentageCircles(document);
        break;
      }
    }
  }).observe(document.documentElement,{childList:true,subtree:true});
})();


/* V7 — keep the Pocket Gamer storefront identity consistent anywhere an older
   source/model name appears. This no longer depends on the optional identity box. */
(function(){
  function pageLooksLikePocketGamer(){
    return /Anbernic|RG35XX|RG35/i.test(document.title||'') ||
      !!document.querySelector('.cosmora-product-identity') ||
      !!document.querySelector('[href*="rg35" i],[href*="anbernic" i]');
  }
  function normalizePocketGamerName(root){
    if(!pageLooksLikePocketGamer()) return;
    var scope=(root && root.nodeType===1)?root:document.body;
    if(!scope) return;
    document.title=(document.title||'')
      .replace(/Anbernic\s*RG35XX[^|–—-]*/gi,'Cosmora Pocket Gamer')
      .replace(/RG35XX/gi,'Cosmora Pocket Gamer')
      .replace(/\bAnbernic\b/gi,'Cosmora');
    var walker=document.createTreeWalker(scope,NodeFilter.SHOW_TEXT,{acceptNode:function(node){
      var p=node.parentElement;
      if(!p || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(p.tagName)) return NodeFilter.FILTER_REJECT;
      return /Anbernic|RG35XX|RG35/i.test(node.nodeValue||'')?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;
    }});
    var nodes=[]; while(walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function(node){
      node.nodeValue=node.nodeValue
        .replace(/Anbernic\s*RG35XX[^\s,.;)]*/gi,'Cosmora Pocket Gamer')
        .replace(/Anbernic\s*RG35XX/gi,'Cosmora Pocket Gamer')
        .replace(/RG35XX/gi,'Cosmora Pocket Gamer')
        .replace(/\bAnbernic\b/gi,'Cosmora');
    });
  }
  function init(){
    normalizePocketGamerName(document.body);
    new MutationObserver(function(mutations){
      if(!pageLooksLikePocketGamer()) return;
      mutations.forEach(function(m){m.addedNodes&&m.addedNodes.forEach(function(n){if(n.nodeType===1)normalizePocketGamerName(n);});});
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',function(){normalizePocketGamerName(document.body)});
})();


/* COSMORA V8.3 — calm product pages without continuously rewriting PagePilot DOM. */
(function(){
  function text(el){return (el && el.textContent || '').replace(/\s+/g,' ').trim();}
  function hideNoisyPagePilotBadges(root){
    var scope=(root && root.querySelectorAll)?root:document;
    scope.querySelectorAll('.pp-product-details .pagepilot-block').forEach(function(block){
      if(block.dataset.cosmoraCheckedBadge==='1') return;
      block.dataset.cosmoraCheckedBadge='1';
      var t=text(block).toLowerCase();
      if(t.indexOf('curated by cosmora')!==-1 ||
         t.indexOf('selected for the cosmora collection')!==-1 ||
         t.indexOf('bestseller of 2026')!==-1 ||
         t.indexOf('trusted by thousands')!==-1){
        block.style.setProperty('display','none','important');
      }
    });
  }
  function simplifyReviewCopy(root){
    var scope=(root && root.querySelectorAll)?root:document;
    scope.querySelectorAll('.pp-reviews-number p').forEach(function(p){
      var t=text(p);
      if(/customer reviews/i.test(t) && !/\d/.test(t) && p.textContent!=='Customer reviews ↓') p.textContent='Customer reviews ↓';
    });
  }
  function ensureReviewStars(root){
    var scope=(root && root.querySelectorAll)?root:document;
    scope.querySelectorAll('.pp-reviews-number').forEach(function(row){
      if(row.querySelector('[data-lucide="star"],svg,.cosmora-review-stars')) return;
      var textWrap=row.querySelector('p');
      if(!textWrap) return;
      var stars=document.createElement('span');
      stars.className='cosmora-review-stars';
      stars.setAttribute('aria-hidden','true');
      stars.textContent='★★★★★';
      var parent=textWrap.parentElement;
      row.insertBefore(stars,parent||row.firstChild);
    });
  }
  function simplify(root){
    if(!document.body || !document.body.classList.contains('template-product')) return;
    hideNoisyPagePilotBadges(root||document);
    simplifyReviewCopy(root||document);
    ensureReviewStars(root||document);
  }
  function staged(){ simplify(document); setTimeout(function(){simplify(document)},250); setTimeout(function(){simplify(document)},900); setTimeout(function(){simplify(document)},1800); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',staged); else staged();
  document.addEventListener('shopify:section:load',function(e){simplify(e.target||document)});
})();

